import axios from "axios";
import { parseXML } from "./xml-utils";

export const parsePriceWithCurrency = text => {
  if (!text || typeof text !== "string") {
    return NaN;
  }

  return parseFloat(text.replace(/[^0-9.]/g, ""));
};

export const parseQuantity = text => {
  let quantity = isNaN(parseInt(text)) ? 0 : parseInt(text);
  if (quantity > 100) {
    quantity = 100;
  }

  return quantity;
};

export const replaceValue = (text, newValue) => {
  if (!text || typeof text !== "string") {
    return "";
  }

  return text.replace(/[0-9][0-9., ]*[0-9]/, newValue.toFixed(2));
};

const currencySymbolToCode = symbolOrCode => {
  let currencyCode;

  switch (symbolOrCode) {
    case "€":
      currencyCode = "EUR";
      break;
    case "$":
    case "US$":
    case "$US":
      currencyCode = "USD";
      break;
    case "HK$":
    case "$HK":
      currencyCode = "HKD";
      break;
    case "NZ$":
    case "$NZ":
      currencyCode = "NZD";
      break;
    case "£":
      currencyCode = "GBP";
      break;
    case "CN¥":
    case "¥CN":
      currencyCode = "CNY";
      break;
    case "CA$":
    case "$CA":
      currencyCode = "CAD";
      break;
    case "R$":
    case "$R":
      currencyCode = "BRL";
      break;
    case "A$":
    case "$A":
      currencyCode = "AUD";
      break;
    case "₹":
      currencyCode = "INR";
      break;
    default:
      currencyCode = symbolOrCode;
      break;
  }

  return currencyCode;
}

export const parseCurrency = text => {
  if (!text || typeof text !== "string") {
    return "";
  }

  return text.replace(/[0-9., ]/g, "");
};

export const parseCurrencyCode = text => currencySymbolToCode(parseCurrency(text))

export const currencyFormatter = (country, currency) => value => {
  if (value === undefined) { // 0 is a valid value.
    return "";
  }

  return value.toLocaleString(country, {
    style: "currency",
    currency: currencySymbolToCode(currency),
  });
};

export const fetchAllPrices = () =>
  axios
    .get("https://www.screenpresso.com/prices.xml")
    /*
    <prices>
      <screenpressopro>
        <en>29.99 €</en>
        <price1>29.99 €</price1>
        <price2>26.99 €</price2>
        <price10>20.99 €</price10>
        <price_site>2190 €</price_site>
      </screenpressopro>
    </prices>
    */
    .then(response => {
      // Expected XML response to be converted into JSON
      return parseXML(response.data).prices.screenpressopro;
    })
    .catch(error => {
      // Do not throw
      console.error(error.message);
    });


